import { useState } from "react";
import BrianyCareLogo from "../../../assets/auth/BrainyCare-Logo.jpg";

const CaptureGuide = ({ setScreen }) => {
  const poses = ["Front", "Left", "Right", "Up", "Down"];






  return (
    <div
      className="w-auto sm:w-[600px] p-6 text-center bg-white"
      style={{
        borderRadius: "12.75px",
        boxShadow: "0 0 4px 0 rgba(179, 67, 67, 0.5)",
        borderColor: "rgba(179, 67, 67, 0.2)",
      }}
    >
      <div className="flex items-center justify-center mb-8 w-full max-w-md">
        <img src={BrianyCareLogo} alt="C-HIM Logo" className="w-10 mr-2" />
        <div className="flex items-center space-x-3">
          <div className="text-xl font-bold text-[#1e90ff] leading-none">
            C-HIM
          </div>
        </div>
      </div>

      <h3 className="text-xl font-semibold text-[#0A0A0A] mb-2">
        Let's capture your face in 5 easy steps
      </h3>
      <p className="text-sm text-[#717182] mb-6">
        This app will guide you through taking 5 photos in different head poses.
        <br />
        Hold each pose steady when instructed.
      </p>

     

      <div className="grid grid-cols-5 gap-3 mb-6">
        {poses.map((pose, index) => (
          <div key={index} className="flex flex-col items-center">
            <div className="w-14 h-14 rounded-md bg-gray-100" />
            <span className="text-xs mt-2 text-[#0A0A0A]">{pose}</span>
          </div>
        ))}
      </div>

      <button
        className={`w-full min-h-[50px] font-medium py-2 px-4 rounded text-white ${
        true
            ? "bg-[#0A0A0A] hover:bg-gray-800"
            : "bg-gray-400 cursor-not-allowed"
        }`}
        onClick={() => setScreen(2)}
     
      >
        Start Face Capture
      </button>
    </div>
  );
};

export default CaptureGuide;
